// import your components at the top
import KayttajalisaysReport from '../report/blocks/KayttajalisaysReport.jsx';
import AutoResizeTextarea from '../report/blocks/AutoResizeTextarea.jsx';
import LexicalShowcase from '../report/blocks/LexicalText/LexicalShowcase.jsx';
import ImageBlock from '../report/blocks/ImageBlock.jsx';
import BulletListBlock from '../report/blocks/BulletListBlock.jsx';
import CoverPageForm from '../report/blocks/CoverPageForm.jsx';
import SubsectionListBlock from '../report/blocks/SubsectionList.jsx';
import PropertyInfoAccordion from '../report/PropertyInfoAccordion.jsx';
import ToimenpideEhdotukset from '../report/blocks/ToimenpideEhdotukset.jsx';
import TeamBlockYrityksella from '../report/blocks/TeamBlockYrityksella.jsx';
import TeamBlockNimikkeella from '../report/blocks/TeamBlockNimikkeella.jsx';
import ToimeksiantajaBlock from '../report/blocks/ToimeksiantajaBlock.jsx';
import KokonaisKuntoarvio from '../report/blocks/Kokonaiskuntoarvio.jsx';
import YmparistoBlock from '../report/blocks/ymparistoBlock.jsx';
import PohjavesiBlock from '../report/blocks/PohjavesiBlock.jsx';
import TulvariskiBlock from '../report/blocks/TulvariskiBlock.jsx';
import MelutasotBlock from '../report/blocks/MelutasotBlock.jsx';
import RadonBlock from '../report/blocks/RadonBlock.jsx';
import { KiinteistoRiskEditor } from '../report/KiinteistoRiskEditor.jsx';
import YhteenvetoToimenpideBlock from '../report/blocks/YhteenvetoToimenpideBlock.jsx';
import EnergiaBlockLinked from '../report/blocks/EnergiaBlockLinked.jsx';
import PTSLongTermTable from '../PTS/PTSLongTermTable.js';
import DynamicPTSTaulu from '../PTS/DynamicPTSTaulu.jsx';
import CapexYhteenveto from '../PTS/CapexYhteenveto.jsx';
import ToimenpiteetTekstimuodossa from '../PTS/ToimenpiteetTekstimuodossa.jsx';
import MapVisualMultiple from '../MapVisualMultiple.jsx';
import MaaraaikaistarkastusTaulukko from '../MaaraaikaistarkastusTaulukko.jsx';
import RakennuslupaTaulukko from '../RakennuslupaTaulukko.jsx';
import SuositeltavatLisatutkimukset from "../report/blocks/SuositeltavatLisatutkimukset.jsx";
import SignatureBlock from '../report/blocks/SignatureBlock.jsx';
import {RiskBlockRakenne,RiskBlockSahko,RiskBlockLVI,} from "../report/blocks/10vRiskiSystemBlocks.jsx";
import ToimenpiteetBlock from '../report/blocks/ToimenpideBlock.jsx';
import MapDebug from './MapDebug.jsx';
import SectionSelectionBlock from '../report/blocks/SectionSelectionBlock.jsx';
import KuntoTable from '../report/blocks/KuntoTable.jsx';
import VaihtoehdotBlock from '../report/blocks/VaihtoehdotBlock.jsx';
import KuntoarviolauseBlock from '../report/blocks/KuntoarviolauseBlock.jsx';
import SubsectionBuilderBlock from '../report/blocks/SubsectionBuilderBlock.jsx';
import PeitepaksuusBlock from '../report/blocks/PeitepaksuusBlock.jsx';
import VetolujuusBlock from '../report/blocks/VetolujuusBlock.jsx';
import PoranayteBlock from '../report/blocks/PoranayteBlock.jsx';
import PdfAttachmentBlock from '../report/blocks/PdfAttachmentBlock.jsx';
import AsbestBlock from '../report/blocks/AsbestBlock.jsx';
import OhuthieBlock from '../report/blocks/OhuthieBlock.jsx';
import KloridipitoisuusBlock from '../report/blocks/KloridipitoisuusBlock.jsx';
import KuntoarviovalikkoBlockV2 from '../report/blocks/julkisivuV2/KuntoarviovalikkoBlockV2.jsx';
import PoranayteBlockV2 from '../report/blocks/julkisivuV2/PoranayteBlockV2.jsx';
import PeitepaksuusBlockV2 from '../report/blocks/julkisivuV2/PeitepaksuusBlockV2.jsx';
import OhuthieBlockV2 from '../report/blocks/julkisivuV2/OhuthieBlockV2.jsx';
import KloridipitoisuusBlockV2 from '../report/blocks/julkisivuV2/KloridipitoisuusBlockV2.jsx';
import VetolujuusBlockV2 from '../report/blocks/julkisivuV2/VetolujuusBlockV2.jsx';
import RappausnayteBlockV2 from '../report/blocks/julkisivuV2/RappausnayteBlockV2.jsx';
import KuntaRadonBlock from '../report/blocks/KuntaRadonBlock.jsx';
import MaaperaBlock from "../report/blocks/MaaperaBlock.jsx";
import LampokameraKorttiBlock
  from "../report/blocks/LampokameraKorttiBlock.jsx";
import LampotilaIndeksiBlock from '../report/blocks/LampotilaIndeksiBlock.jsx';
import HuoneistoKortitBlock
  from "../report/blocks/HuoneistoKortitBlock.jsx";
  import WeatherBlock from "../report/blocks/WeatherBlock.jsx";
//noBlur määrittelee näytetäänkö yhteyden menetyksen jälkeeen

// ─── Block Registry ─────────────────────────────
export const blockRegistry = {
  ReportUsersBlock: { component: KayttajalisaysReport, label: 'Raportin käyttäjät' },
  textarea: { component: AutoResizeTextarea, label: 'Tekstikenttä (VANHA)' },
  LexicalTextarea: { component: LexicalShowcase, label: 'Tekstikenttä' },
  ImageBlock: { component: ImageBlock, label: 'Kuvat', noBlur: true},
  BulletListBlock: { component: BulletListBlock, label: "Luettelo" },
  coverPageForm: { component: CoverPageForm, label: 'Kansilehti' },
  subsectionlist: { component: SubsectionListBlock, label: 'Aliotsikot WK3' },
  propertyInfo: { component: PropertyInfoAccordion, label: 'Kiinteistön tiedot' },
  ToimenpideEhdotukset: { component: ToimenpideEhdotukset, label: "Toimenpide-ehdotukset" },
  Toimenpiteet: {component: ToimenpiteetBlock, label: 'Toimenpiteet'},
  teamBlockYrityksella: { component: TeamBlockYrityksella, label: 'Tekijät (Yrityksellä)' },
  TeamBlockNimikkeella: { component: TeamBlockNimikkeella, label: 'Tekijät' },
  ToimeksiantajaBlock: { component: ToimeksiantajaBlock, label: 'Toimeksiantaja' },
  KokonaisKuntoarvio: { component: KokonaisKuntoarvio, label: 'Kokonaiskuntoarvio' },
  YmparistoBlock: { component: YmparistoBlock, label: "Ympäristötiedot" },
  RadonBlock: { component: RadonBlock, label: 'Radon' },
  MaaperaBlock: {component: MaaperaBlock, label: "Maaperän tila"
},
  KuntaRadonBlock: { component: KuntaRadonBlock, label: 'Kunnan radon' },
  PohjavesiBlock: { component: PohjavesiBlock, label: 'Pohjavesialueet' },
  TulvariskiBlock: { component: TulvariskiBlock, label: 'Tulvariskialueet' },
  RiskBlock: { component: KiinteistoRiskEditor, label: 'Järjestelmäkuvaus' },
  subsection: { component: null, label: 'Aliosio' },
  subsection2: { component: null, label: "Aliosio (bold header)" },
  YhteenvetoToimenpideBlock: { component: YhteenvetoToimenpideBlock, label: "Yhteenveto – Toimenpiteet" },
  EnergiaBlockHeat: { component: EnergiaBlockLinked, label: "Lämmön kulutus" },
  EnergiaBlockWater: { component: EnergiaBlockLinked, label: "Veden kulutus" },
  EnergiaBlockElectricity: { component: EnergiaBlockLinked, label: "Sähkön kulutus" },
  PtsBlockYhteenveto: { component: PTSLongTermTable, label: 'PTS (Yhteenveto)', showPart: 'pts-yhteenveto' },
  PtsBlockTalous: { component: PTSLongTermTable, label: 'PTS (Talous)', showPart: 'pts-talous' },
  PtsBlockRakennetekniikka: { component: PTSLongTermTable, label: 'PTS (Rakennetekniikka)', showPart: 'pts-rakenne' },
  PtsBlockLVI: { component: PTSLongTermTable, label: 'PTS (LVI Järjestelmät)', showPart: 'pts-lvi' },
  PtsBlockSahko: { component: PTSLongTermTable, label: 'PTS (Sähköjärjestelmät)', showPart: 'pts-sähkö' },
  PtsBlockTutkimukset: { component: PTSLongTermTable, label: 'PTS (Lisätutkimukset)', showPart: 'pts-tutkimustarpeet' },
  PtsBlockKokonaan: { component: PTSLongTermTable, label: 'PTS (Kokonaan)', showPart: 'all' },
  PtsBlockDynamic: { component: DynamicPTSTaulu, label: 'PTS (Kuntoarviovalikko)' },
  CapexYhteenvetoBlock: { component: CapexYhteenveto, label: 'Capex-yhteenveto' },
  ToimenpiteetTekstimuodossaBlock: { component: ToimenpiteetTekstimuodossa, label: 'Toimenpiteet tekstimuodossa' },
  MapBlock2: { component: MapVisualMultiple, label: 'Kartta', showPart: 'kartta' },
  SuositeltavatLisatutkimukset: { component: SuositeltavatLisatutkimukset, label: 'Suositeltavat lisätutkimukset' },
  SignatureBlock: { component: SignatureBlock, label: 'Allekirjoitus' },
  RiskBlockRakenne: { component: RiskBlockRakenne,label: "Riskiraportti – Rakennetekniikka"},
  RiskBlockSahko: {component: RiskBlockSahko,label: "Riskiraportti – Sähköjärjestelmät"},
  RiskBlockLVI: {component: RiskBlockLVI,label: "Riskiraportti – LVI Järjestelmät"},
  MapImage: {component: MapDebug, label: "Karttakuva"},
  MelutasotBlock: {
  component: MelutasotBlock,
  label: "Melutasot"
},
  SectionSelectionBlock: { component: SectionSelectionBlock, label: 'Osioiden valinta' },
  KuntoTable: { component: KuntoTable, label: 'Kuntotaulukko' },
  MaaraaikaistarkastusTaulukko: { component: MaaraaikaistarkastusTaulukko, label: 'Määräaikaistarkastustaulukko' },
  RakennuslupaTaulukko: { component: RakennuslupaTaulukko, label: 'Rakennuslupataulukko' },
  VaihtoehdotBlock: { component: VaihtoehdotBlock, label: 'Vaihtoehdot' },
  KuntoarviolauseBlock: { component: KuntoarviolauseBlock, label: 'Kuntoarviolause' },
  SubsectionBuilderBlock: { component: SubsectionBuilderBlock, label: 'Kuntoarviovalikko' },
  PeitepaksuusBlock: { component: PeitepaksuusBlock, label: 'Peitepaksuus' },
  VetolujuusBlock: { component: VetolujuusBlock, label: 'Vetolujuus' },
  PoranayteBlock: { component: PoranayteBlock, label: 'Poranäyte' },
  PdfAttachmentBlock: { component: PdfAttachmentBlock, label: 'PDF-liite' },
  AsbestBlock: { component: AsbestBlock, label: 'Asbesti' },
  OhuthieBlock: { component: OhuthieBlock, label: 'Ohuthie' },
  KloridipitoisuusBlock: { component: KloridipitoisuusBlock, label: 'Kloridipitoisuus' },
  KuntoarviovalikkoBlockV2: { component: KuntoarviovalikkoBlockV2, label: 'Kuntoarviovalikko (v2)' },
  PoranayteBlockV2: { component: PoranayteBlockV2, label: 'Poränäyte (v2)' },
  PeitepaksuusBlockV2: { component: PeitepaksuusBlockV2, label: 'Peitepaksuus (v2)' },
  OhuthieBlockV2: { component: OhuthieBlockV2, label: 'Ohuthie (v2)' },
  KloridipitoisuusBlockV2: { component: KloridipitoisuusBlockV2, label: 'Kloridipitoisuus (v2)' },
  VetolujuusBlockV2: { component: VetolujuusBlockV2, label: 'Vetolujuus (v2)' },
  RappausnayteBlockV2: { component: RappausnayteBlockV2, label: 'Rappausnäyte (v2)' },
  LampotilaIndeksiBlock: { component: LampotilaIndeksiBlock, label: 'Lämpötilaindeksi' },
  HuoneistoKortitBlock: {
  component: HuoneistoKortitBlock,
  label: "Huoneistokortit",
  },
  LampokameraKorttiBlock: {
    component: LampokameraKorttiBlock,
    label: "Lämpökamerakortti",
},
WeatherBlock: {
  component: WeatherBlock,
  label: "Ulkoilman olosuhteet",
}

};

// ─── Categorized Registry ──────────────────────
export const categorizedBlockRegistry = {
  Teksti: {
    LexicalTextarea: blockRegistry.LexicalTextarea,
    BulletListBlock: blockRegistry.BulletListBlock,
  },
  'Osio / Aliosio': {
    subsection: blockRegistry.subsection,
    subsection2: blockRegistry.subsection2,
    subsectionlist: blockRegistry.subsectionlist,
    coverPageForm: blockRegistry.coverPageForm,
    SectionSelectionBlock: blockRegistry.SectionSelectionBlock,
    SubsectionBuilderBlock: blockRegistry.SubsectionBuilderBlock,
  },
  'Kuvat / Media': {
    ImageBlock: blockRegistry.ImageBlock,
    MapBlock2: blockRegistry.MapBlock2,
    SignatureBlock: blockRegistry.SignatureBlock,
    MapImage: blockRegistry.MapImage,
    PdfAttachmentBlock: blockRegistry.PdfAttachmentBlock,
  },
  'Arvioinnit / Raportit': {
    KokonaisKuntoarvio: blockRegistry.KokonaisKuntoarvio,
    ToimenpideEhdotukset: blockRegistry.ToimenpideEhdotukset,
    Toimenpiteet: blockRegistry.Toimenpiteet,
    SuositeltavatLisatutkimukset: blockRegistry.SuositeltavatLisatutkimukset,
    YhteenvetoToimenpideBlock: blockRegistry.YhteenvetoToimenpideBlock,
    RiskBlock: blockRegistry.RiskBlock,
    RiskBlockRakenne: blockRegistry.RiskBlockRakenne,
    RiskBlockSahko: blockRegistry.RiskBlockSahko,
    RiskBlockLVI: blockRegistry.RiskBlockLVI,
    propertyInfo: blockRegistry.propertyInfo,
  },
  'Tiimit / Käyttäjät': {
    teamBlockYrityksella: blockRegistry.teamBlockYrityksella,
    TeamBlockNimikkeella: blockRegistry.TeamBlockNimikkeella,
    ReportUsersBlock: blockRegistry.ReportUsersBlock,
    ToimeksiantajaBlock: blockRegistry.ToimeksiantajaBlock,
  },
  'Kunto / Taulukot': {
    KuntoTable: blockRegistry.KuntoTable,
    VaihtoehdotBlock: blockRegistry.VaihtoehdotBlock,
    KuntoarviolauseBlock: blockRegistry.KuntoarviolauseBlock,
    PeitepaksuusBlock: blockRegistry.PeitepaksuusBlock,
    VetolujuusBlock: blockRegistry.VetolujuusBlock,
    PoranayteBlock: blockRegistry.PoranayteBlock,
    AsbestBlock: blockRegistry.AsbestBlock,
    OhuthieBlock: blockRegistry.OhuthieBlock,
    KloridipitoisuusBlock: blockRegistry.KloridipitoisuusBlock,
    LampotilaIndeksiBlock: blockRegistry.LampotilaIndeksiBlock,
    HuoneistoKortitBlock: blockRegistry.HuoneistoKortitBlock,
  },
  'Tarkastukset / Huolto': {
    MaaraaikaistarkastusTaulukko: blockRegistry.MaaraaikaistarkastusTaulukko,
  },
  'Luvat / Rekisterit': {
    RakennuslupaTaulukko: blockRegistry.RakennuslupaTaulukko,
  },
  'Julkisivu v2': {
    KuntoarviovalikkoBlockV2: blockRegistry.KuntoarviovalikkoBlockV2,
    PoranayteBlockV2: blockRegistry.PoranayteBlockV2,
    PeitepaksuusBlockV2: blockRegistry.PeitepaksuusBlockV2,
    OhuthieBlockV2: blockRegistry.OhuthieBlockV2,
    KloridipitoisuusBlockV2: blockRegistry.KloridipitoisuusBlockV2,
    VetolujuusBlockV2: blockRegistry.VetolujuusBlockV2,
    RappausnayteBlockV2: blockRegistry.RappausnayteBlockV2,
  },
  'PTS / Taulukot': {
    PtsBlockYhteenveto: blockRegistry.PtsBlockYhteenveto,
    PtsBlockTalous: blockRegistry.PtsBlockTalous,
    PtsBlockRakennetekniikka: blockRegistry.PtsBlockRakennetekniikka,
    PtsBlockLVI: blockRegistry.PtsBlockLVI,
    PtsBlockSahko: blockRegistry.PtsBlockSahko,
    PtsBlockTutkimukset: blockRegistry.PtsBlockTutkimukset,
    PtsBlockKokonaan: blockRegistry.PtsBlockKokonaan,
    PtsBlockDynamic: blockRegistry.PtsBlockDynamic,
    CapexYhteenvetoBlock: blockRegistry.CapexYhteenvetoBlock,
    ToimenpiteetTekstimuodossaBlock: blockRegistry.ToimenpiteetTekstimuodossaBlock,
  },
  Energia: {
    EnergiaBlockHeat: blockRegistry.EnergiaBlockHeat,
    EnergiaBlockWater: blockRegistry.EnergiaBlockWater,
    EnergiaBlockElectricity: blockRegistry.EnergiaBlockElectricity,
    LampokameraKorttiBlock: blockRegistry.LampokameraKorttiBlock,
  },
 Ymparisto: {
  YmparistoBlock: blockRegistry.YmparistoBlock,
  PohjavesiBlock: blockRegistry.PohjavesiBlock,
  TulvariskiBlock: blockRegistry.TulvariskiBlock,
  MaaperaBlock: blockRegistry.MaaperaBlock,
  MelutasotBlock: blockRegistry.MelutasotBlock,
  RadonBlock: blockRegistry.RadonBlock,
  KuntaRadonBlock: blockRegistry.KuntaRadonBlock,
  WeatherBlock: blockRegistry.WeatherBlock,
},

};

// ─── Energia Index Map ─────────────────────────
export const energiaIndexMap = {
  EnergiaBlockHeat: 0,
  EnergiaBlockWater: 1,
  EnergiaBlockElectricity: 2,
};
